export enum EnumTipoMedidor {
  SinInformar = -1,
  Contador = 1,
  Corrector = 2,
  UnidadRemota = 3
}